import { EnLan } from "./EnLan";
import { FaLan } from "./FaLan";

export const Language = {
    "en": EnLan,
    "fa": FaLan
}